const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
};

const header = ['タイトル', 'ワークスペース', 'カテゴリー', '対象', '作成日時', '更新日時', ''];

const table = [
    {
        item: [
            {
                text: 'Topicsタイトル',

            },
            {
                text: 'ワークスペース名',
            },
            {
                text: 'Game Topics',
            },
            {
                text: '8/3 巨人 - 中日',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                action: [
                    'ワークスペースにコピー',
                    '複製',
                    '編集',
                    '削除',
                ],
            },
        ],
    },
    {
        item: [
            {
                text: 'Topicsタイトル',
            },
            {
                text: 'ワークスペース名',
            },
            {
                text: 'Game Topics',
            },
            {
                text: '8/3 巨人 - 中日',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                action: [
                    'ワークスペースにコピー',
                    '複製',
                    '編集',
                    '削除',
                ],
            },
        ],
    },
    {
        item: [
            {
                text: 'Topicsタイトル',
            },
            {
                text: 'ワークスペース名',
            },
            {
                text: 'Game Topics',
            },
            {
                text: '8/3 巨人 - 中日',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                action: [
                    'ワークスペースにコピー',
                    '複製',
                    '編集',
                    '削除',
                ],
            },
        ],
    },
    {
        item: [
            {
                text: 'Topicsタイトル',
            },
            {
                text: 'ワークスペース名',
            },
            {
                text: 'Game Topics',
            },
            {
                text: '8/3 巨人 - 中日',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                action: [
                    'ワークスペースにコピー',
                    '複製',
                    '編集',
                    '削除',
                ],
            },
        ],
    },
    {
        item: [
            {
                text: 'Topicsタイトル',
            },
            {
                text: 'ワークスペース名',
            },
            {
                text: 'Game Topics',
            },
            {
                text: '8/3 巨人 - 中日',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                text: '2019/11/23 12:34',
            },
            {
                action: [
                    'ワークスペースにコピー',
                    '複製',
                    '編集',
                    '削除',
                ],
            },
        ],
    },
];

export default (state = { header, table }, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_DATA_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};